import { useRef, useState } from 'react';
import images from '../../../assets/images';
import { useAppSelector } from '../../../redux/app/hooks';
import { SCHOOL_ADMIN } from '../../../utils/constants';
import { getScreenDimensions } from '../../../utils/helper';
import { announcementObjectType } from '../AdminAnnouncement';
import './AnnouncementViewer.scss';
import { Tooltip } from '@mui/material';
interface propsType {
    displayDetailedView: boolean;
    setDisplayDetailedView: any;
    singleAnnouncementDetail: announcementObjectType | undefined;
}
const AnnouncementViewer = ({ displayDetailedView, setDisplayDetailedView, singleAnnouncementDetail }: propsType) => {
    const { backArrow, AnnouncementImage } = images;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const role = useAppSelector((state) => state.auth.role);

    const titleRef = useRef<HTMLDivElement | null>(null);
    const [isOverflow, setIsOverflow] = useState(false);
  
    const checkOverflow = () => {
      if (titleRef.current) {
        setIsOverflow(titleRef.current.scrollWidth > titleRef.current.clientWidth);
      }
    };

    return (
        <div className={role === SCHOOL_ADMIN ? "AnnouncementViewer" : "TeacherStudentAnnouncementViewer"}>
            <div className='adminAnnouncementFormHeader'>
                <img
                    onClick={() => { setDisplayDetailedView(!displayDetailedView) }}
                    className="backArrow"
                    alt="back-arrow"
                    src={backArrow}
                />
                {getScreenDimensions()?.isMobileScreen && <>
                    <label className={role === SCHOOL_ADMIN ? 'announcementTitle':'teacherStudentAnnouncementTitle'}>{singleAnnouncementDetail?.aOriginalTitle}</label>
                    <span className="mobileHeaderSeperator" />
                </>}

            </div>
            <div className='AnnouncementDetailsOuterCtn'>
            <div className={role === SCHOOL_ADMIN ? 'AnnouncementDetails' : 'TeacherStudentAnnouncementDetails'}>
                <img
                    src={singleAnnouncementDetail?.aUrl ? baseUrl + singleAnnouncementDetail?.aUrl : AnnouncementImage}
                    alt='avatarUrl'
                    className='announcementImage'
                />
                <div className='announcementContentCtn'>
                    {!getScreenDimensions()?.isMobileScreen && <>
                        <Tooltip title={singleAnnouncementDetail?.aOriginalTitle} disableHoverListener={!isOverflow} placement="top">
          <div
            ref={titleRef}
            onMouseEnter={checkOverflow} // Check overflow only when hovering
            className={role === "SCHOOL_ADMIN" ? "announcementTitle" : "teacherStudentAnnouncementTitle"}
            style={{ whiteSpace: "pre", overflow: "hidden", textOverflow: "ellipsis" }}
          >
            {singleAnnouncementDetail?.aOriginalTitle}
          </div>
        </Tooltip>                    </>}
                    <p className={role === SCHOOL_ADMIN ? 'announcementMessage':'teacherStudentAnnouncementMessage'}>
                        {singleAnnouncementDetail?.aMessage}
                    </p>
                </div>
            </div>
            </div>
        </div>
    )
}

export default AnnouncementViewer;